import { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

export default function CategorySelect({ categories, form, setForm }) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!dropdownRef.current?.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selected = categories.find((c) => c.id === form.category);
console.log("Selected category:", categories);
  return (
    <div className="relative w-full" ref={dropdownRef}>
      {/* Trigger */}
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full p-3 border rounded-xl bg-white flex items-center justify-between hover:border-gray-400 transition"
      >
        <div className="flex items-center gap-2">
          {selected?.icon && <span>{selected.icon}</span>}
          <span>
            {selected ? selected.name : "Select category"}
          </span>
        </div>
        <ChevronDown size={18} />
      </button>

      {/* Dropdown */}
      {open && (
        <div className="absolute z-50 mt-2 w-full bg-white border rounded-xl shadow-lg max-h-60 overflow-y-auto">
          {categories.map((c) => (
            <div
              key={c.id}
              onClick={() => {
                setForm((s) => ({ ...s, category: c.id }));
                setOpen(false);
              }}
              className="flex items-center gap-3 p-3 hover:bg-gray-100 cursor-pointer transition"
            >
              {c.icon && <span className="text-lg">{c.icon}</span>}
              <span>{c.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}